/// <amd-module name="Wit/SprintsHub/SprintsView/Components/SprintHeader/FormDirtyDialog" />
import * as React from "react";
import { Dialog } from "VSSUI/Dialog";
import * as Resources from "Wit/SprintsHub/SprintsView/Resources";

interface IFormDirtyDialogProps {
    dismissDirtyForm: () => void;
    onDismiss: () => void
}

export const FormDirtyDialog: React.FunctionComponent<IFormDirtyDialogProps> = ({ dismissDirtyForm, onDismiss }) => {
    return (
        <Dialog
            lightDismiss={false}
            onDismiss={() => onDismiss()}
            titleProps={{ text: Resources.FormDirtyDialogTitle }}
            footerButtonProps={[
                {
                    text: Resources.Ok,
                    onClick: () => dismissDirtyForm(),
                    primary: true
                },
                {
                    text: Resources.Cancel,
                    onClick: () => onDismiss()
                }
            ]}
        />
    );
}